var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TabLanguages',{attrs:{"tabLanguages":_vm.getLanguages,"activeLanguage":_vm.getTabLanguage.lang,"tabErrors":_vm.tabErrors},on:{"tabLanguageChanged":_vm.onTabLanguageChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }